import { Skeleton as MuiSkeleton } from '@mui/material';
import { styled } from '@innowise-group/mui-kit';

export const Skeleton = styled(MuiSkeleton)`
  &.MuiSkeleton-root {
    ${({ theme }) => theme.fonts.primary[10]};
    background-color: ${({ theme }) => theme.palette.general.lightGrey[40]};
  }
`;
